import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthShell } from '../components/AuthShell';
import { Field, ErrorBanner } from '../components/ui';
import { api, ApiError } from '../lib/api';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, newPassword: password });
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 1500);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Unable to reset password.');
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <AuthShell title="Reset password">
        <ErrorBanner message="This reset link is missing its token. Request a new link." />
        <p className="mt-4 text-center text-sm">
          <Link to="/forgot-password" className="text-grove underline">
            Request a new reset link
          </Link>
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password">
      {done ? (
        <p className="rounded border border-success/30 bg-success/5 px-4 py-3 text-sm text-body">
          Your password has been reset. Redirecting to sign in…
        </p>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          {error && (
            <div className="mb-4">
              <ErrorBanner message={error} />
            </div>
          )}
          <Field label="New password" htmlFor="password" hint="At least 8 characters.">
            <input
              id="password"
              type="password"
              required
              minLength={8}
              className="input"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          <button type="submit" className="btn-primary btn-lg w-full" disabled={busy}>
            {busy ? 'Saving…' : 'Reset password'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
